namespace advisorop.components.advisor {

  export class AdvisorExternalSystemController {

    $router;
    user: domains.identity.IUser = {};
    isAdmin = false;
    externalSystems: Array<domains.IAdvisorExternalSystem>;
    syncingSalesforceContacts: boolean = false;
    syncingSalesforceHouseholds: boolean = false;
    resetsyncSalesforce: boolean = false;
    updatingSalesforce: boolean = false;
    syncMessage: domains.externalsystem.ISyncDataMessage;

    static $inject = ["advisorService", "identityService", "$rootRouter", "$scope"];

    constructor(private advisorService: services.AdvisorService, private identityService: services.IdentityService, public $rootRouter) {
    }

    $onInit(): void {
      //this.loadExternalSystems();
      this.getUser();
    }

    getUser() {
      this.identityService.getUserPromise().then(response => {
        this.user = response;
        if (this.user.role === domains.AdvisoryRoles.ADVISORY_ADMIN.toString()) this.isAdmin = true;
        this.loadExternalSystems();
      });
    }

    runWizard(ext: domains.IExternalSystem) {
      toastr.error("Only Advisory Admin can access!");
    }

    loadExternalSystems(): void {
      this.advisorService.getExternalSystems()
        .then((data) => {
          this.externalSystems = data.data;
          //console.log("# _externalSystems:", this.externalSystems);
        })
        .catch((reason) => {
          console.log("Error during load externalSystems");
          console.log(reason);
        });
    }

    $routerOnActivate(next, previous) {
    }

    syncData(system: domains.IAdvisorExternalSystem) {
      this.syncingSalesforceContacts = true;

      var startDate = new Date();

      // Do your operations

      toastr.info(`Synchronizing data with ${system.name} started at ${new Date().toLocaleTimeString()}!`);
      this.advisorService.syncData(system.id)
        .then((data) => {
          //console.log("# _sync_data:", data);

          var message = data.data;
          this.syncMessage = data.data;

          message.dataErrors.forEach(e => {
            toastr.error(e.description);
          });

          if (message.dataSuccess) {
            toastr.success(
              ` - ${message.advisorCreatedRecords} records were created on AdvisorOp!<br/>- ${message.advisorUpdatedRecords} records were updated on AdvisorOp!<br/>- ${message.advisorDeletedRecords} records were deleted on AdvisorOp!<br/>- ${message.externalCreatedRecords} records were created on ${system.name}!<br/>- ${message.externalUpdatedRecords} records were updated on ${system.name}!<br/>- ${message.externalDeletedRecords} records were deleted on ${system.name}!<br/>`, 'Synchronization review');
          }
          var endDate = new Date();
          var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
          toastr.success(`Synchronization process time : ${seconds} seconds, finished with: ${message.dataErrors.length} errors!`);
        })
        .catch((reason) => {
          console.log("Error during load externalSystems");
          console.log(reason);
          }).finally(() => {
              this.syncingSalesforceContacts = false;
          });
    }

      updateFromMigration(system: domains.IAdvisorExternalSystem) {
          this.updatingSalesforce = true;
          this.advisorService.updateFromMigration(undefined)
              .then((data) => {
                  //console.log("Updating from migration succeeded.");
              })
              .catch((reason) => {
                  console.log("Error updating from migration");
                  console.log(reason);
              })
              .finally(() => {
                  this.updatingSalesforce = false;
              });
      }

    syncHouseholdData(system: domains.IAdvisorExternalSystem) {
      this.syncingSalesforceHouseholds = true;

      var startDate = new Date();

      // Do your operations

      toastr.info(`Synchronizing household data with ${system.name} started at ${new Date().toLocaleTimeString()}!`);
      this.advisorService.syncHouseholdData(system.id)
        .then((data) => {
          //console.log("# _sync_data:", data);

          var message = data.data;
          this.syncMessage = data.data;

          message.dataErrors.forEach(e => {
            toastr.error(e.description);
          });

          if (message.dataSuccess) {
            toastr.success(
              ` - ${message.advisorCreatedRecords} records were created on AdvisorOp!<br/>- ${message.advisorUpdatedRecords} records were updated on AdvisorOp!<br/>- ${message.advisorDeletedRecords} records were deleted on AdvisorOp!<br/>- ${message.externalCreatedRecords} records were created on ${system.name}!<br/>- ${message.externalUpdatedRecords} records were updated on ${system.name}!<br/>- ${message.externalDeletedRecords} records were deleted on ${system.name}!<br/>`, 'Synchronization review');
          }
          var endDate = new Date();
          var seconds = (endDate.getTime() - startDate.getTime()) / 1000;
          toastr.success(`Synchronization process time : ${seconds} seconds, finished with: ${message.dataErrors.length} errors!`);
        })
        .catch((reason) => {
          console.log("Error during load externalSystems");
          console.log(reason);
        }).finally(() => {
          this.syncingSalesforceHouseholds = false;
        });
    }

    resetSyncData(system: domains.IAdvisorExternalSystem) {
        this.resetsyncSalesforce = true;

      this.advisorService.resetSyncData(system.id)
        .then((data) => {
          //console.log("# _resret_sync_data:", data);

        })
        .catch((reason) => {
          console.log("Error during reset externalSystem sync");
          console.log(reason);
          }).finally(() => {
              this.resetsyncSalesforce = false;
          });
    }
  }


  class AdvisorExternalSystem implements ng.IComponentOptions {

    public bindings: any;
    public controller: any;
    public controllerAs: string;
    public templateUrl: string;
    public $routeConfig: any;

    constructor() {
      this.bindings = {
        $router: "<"
      };
      this.controller = AdvisorExternalSystemController;
      this.controllerAs = "vm";
      this.templateUrl = 'spa/advisor-module/views/advisor-external-systems.html';
    }
  }
  angular.module(Constants.APP).component("advisorExternalSystem", new AdvisorExternalSystem());
}